import React, { useState } from 'react';
import {withStyles} from "@mui/styles";
import { Link, useNavigate } from "react-router-dom";
import { connect, setStore } from "trim-redux";
import { getMediaURL, truncate } from "../../../../config/values";
import Button from "@mui/material/Button";

import { Styles } from "../../../../config/design/styles";
import {ChevronDown, LogOut, UserRound} from "lucide-react";
import {
    IconButton,
    Menu,
    MenuItem,
    useMediaQuery
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {isAdmin, isCourier, isSupplier, isUser} from "../../../../config/Permissions";
import LogoutDialog from "./LogoutDialog";
import {theme} from "../../../../config/design/theme";
import Badge from '@mui/material/Badge';

function UserMenu({ classes, style, className, isAuth, width, user }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const navigate = useNavigate();
    const { t } = useTranslation();

    const openLink = (url) => {
        navigate(url);
        handleClose();
    };

    return (
        <>
            {user && (
                <div className={classes.usermenu}>
                    {
                        !isMobile ?
                            <Button
                                startIcon={<UserRound className="lucide-icon"/>}
                                endIcon={<ChevronDown className="lucide-icon"/> }
                                color="default"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick}
                            >
                                {truncate(user.first_name+" "+user.last_name, 10)}
                            </Button>
                            :
                            <IconButton
                                color="default"
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick}
                            >
                                <UserRound className="lucide-icon-text"/>
                            </IconButton>
                    }

                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        className={"auth-menu"}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        {
                            !!isAdmin() &&
                                <MenuItem onClick={() => openLink('/panel')}>{t('adminPanel')}</MenuItem>
                        }
                        {
                            !!isSupplier() &&
                                <MenuItem onClick={() => openLink('/panel')}>{t('shopPanel')}</MenuItem>
                        }
                        {
                            !!isCourier() &&
                                <MenuItem onClick={() => openLink('/account/courier-orders')}>{t('courierOrders')}</MenuItem>
                        }
                        {
                            !!isUser() &&
                            <MenuItem onClick={() => openLink('/account/my-orders')}>{t('myOrders')} {!!user.active_orders && <span style={{color:"#F0051F",marginLeft:5}}> {` (${user.active_orders})`}</span>}</MenuItem>
                        }
                        <MenuItem onClick={() => openLink('/account/details')}>{t('myAccount')}</MenuItem>
                        {
                            !isAdmin() &&
                            <MenuItem onClick={() => openLink('/account/support')}>{t('support')} {!!user.umc && <span style={{color:"#F0051F",marginLeft:5}}> {` (${user.umc})`}</span>}</MenuItem>
                        }
                        <MenuItem onClick={() => {
                            setDialogOpen(true)
                            handleClose()
                        }}>{t('logOut')}</MenuItem>

                    </Menu>
                    <LogoutDialog logoutOpen={dialogOpen} closeDialog={() => setDialogOpen(false)}/>
                </div>
            )}
        </>
    );
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_color: state.primary_color
});

export default withStyles(Styles)(connect(mstp)(UserMenu));
